import Axios from '~/utils/axios';
import { useQuery } from 'react-query';
import { sentryCaptureException } from '~/errors/sentry';

const useTimeSlots = (id: string | undefined | string[], setDataState?: (data: any) => void) => {
   const getTimeSlots = async () => {
      const { data } = await Axios.get(`/hy-providers/v1/products/${id}/timeslots`);
      return data;
   };

   return useQuery(['time-slots', id], getTimeSlots, {
      enabled: !!id,
      refetchOnWindowFocus: false,
      onSuccess: setDataState,
      onError: (error: Error) => {
         sentryCaptureException(error, { tags: { journey: 'business' } });
      },
   });
};

export default useTimeSlots;
